import { EntityDataTypes, EntityEndpoint } from 'src/interfaces/modular/entityInfoTypes';
export const isInstance = (entity) => entity.type === EntityDataTypes.Instance;
export const isCollection = (entity) => entity.type === EntityDataTypes.Collection;
export const isCentral = (endpoint) => endpoint === EntityEndpoint.Central;
